import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Arrow from '../../shared/component/Arrow';
import { WorkArtistData } from '../../shared/dto/EntityRepository';
import { useEditMode } from '../../shared/hooks/useEditMode';

interface WorkArtistNameProps {
  artist: WorkArtistData | null | undefined;
  name: string;
  className?: string;
}

const WorkArtistName: React.FC<WorkArtistNameProps> = ({ artist, name, className }) => {
  const { isEditMode } = useEditMode();
  if (!name) return null;

  if (!isEditMode && artist?.linkedMemberHandle) {
    return (
      <ArtistLink
        className={className}
        to={`/@${artist.linkedMemberHandle}/`}
        onClick={(event) => event.stopPropagation()}
      >
        {name}
        <ArrowWrapper>
          <Arrow />
        </ArrowWrapper>
      </ArtistLink>
    );
  }

  return <ArtistText className={className}>{name}</ArtistText>;
};

export default WorkArtistName;

const ArtistText = styled.span`
  color: inherit;
`;

const ArrowWrapper = styled.span`
  width: 12px;
  height: 12px;
  margin-left: auto;
  padding-right: 2px;
  display: flex;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  svg {
    width: 10px;
    height: 10px;
    padding-top: 0;
  }
`;

const ArtistLink = styled(Link)`
  width: 100%;
  height: 16px;
  display: inline-flex;
  align-items: center;
  gap: clamp(4px, 0.4vw, 8px);
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;

    ${ArrowWrapper} {
      opacity: 1;
    }
  }
`;
